
    import Carousel from '@/components/Utils/Carousel';
    import { imgResize } from '@/utils/helpers';

    export default {
        name: 'CompanyCarousel',

        components: {
            Carousel,
        },

        props: {
            media: {
                type: Array,
                default: () => ([]),
            },

            company: {
                type: String,
                required: true,
            },

            height: {
                type: Number,
                default: 0,
            },

            width: {
                type: Number,
                default: 0,
            },

            randomised: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                breakpoints: {
                    250: {
                        perView: 1,
                        peek: 0,
                    },
                },
            };
        },

        computed: {
            customHeight() {
                return this.height ? {
                    height: `${this.height}px`,
                } : '';
            },

            imageWidth() {
                return this.width || 1024;
            },

            imageHeight() {
                return this.height || 600;
            },
        },

        methods: {
            imgUrl(url) {
                return imgResize(url, this.imageWidth, this.imageHeight);
            },

            onClick() {
                this.$emit('click');
            },
        },
    };
